module.exports = __webpack_public_path__ + "img/5_h_uk.141964b1.svg";